import { connect } from "react-redux";
import CascadeFilter from "components/organisms/CascadeFilter";
import { filterChange, filterMounted } from "actions";

const mapStateToProps = (state, ownProps) => {
  const name = ownProps.name;
  const filterState = state.filters[name];

  return {
    name,
    label: ownProps.label || filterState.label,
    currentValues: filterState.currentValues || filterState.values,
    filteredValues: filterState.values,
    data: filterState.data ? filterState.data : [],
    loadingLevel: filterState.loadingLevel,
    columnCount: ownProps.columnCount || filterState.columnCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterChange: (name, values) => {
      values = values ? values : [];

      dispatch(filterChange(name, values));
    },
    onMountStateChange: (name, mounted) => {
      dispatch(filterMounted(name, mounted));
    },
  };
};

const CascadeFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CascadeFilter);

export default CascadeFilterContainer;
